import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  formData: {
    category_id: '',
    category_name: '',
    category_section: '',
  },  // Menyimpan data yang diambil
  dataList: [],  // Menyimpan list data untuk persistence
  totalData: 0,  // Menyimpan total count untuk persistence
  loading: false,  // Menyimpan status loading
  error: null,  // Menyimpan pesan error jika ada
  loadingMessage: '',
  activeTab: 0,  // Menyimpan tab yang aktif (0 untuk List, 1 untuk Data)
};

const mst07categorySlice = createSlice({
  name: 'mst07category',  // Nama slice yang sesuai
  initialState,
  reducers: {
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    clearFormData: (state) => {
      state.formData = initialState.formData;  // Mengatur ulang formData ke nilai awal
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setErrorMsg: (state, action) => {
      state.error = action.payload;
    },
    setLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload;
    },
    fetchDetailSuccess: (state, action) => {
      state.formData = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDetailError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: (state) => {
      return initialState;  // Mengatur ulang semua state ke nilai awal
    },
    setActiveTab: (state, action) => {
      console.log('🔄 Redux setActiveTab called with:', action.payload, '(mst07category)');
      state.activeTab = action.payload;
    },
    setDataList: (state, action) => {
      state.dataList = action.payload;
    },
    setTotalData: (state, action) => {
      state.totalData = action.payload;
    },
    clearModuleState: (state) => {
      console.log('🧹 Clearing mst07category module state for fresh navigation');
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = {
        category_id: '',
        category_name: '',
        category_section: '',
      };
    },
  },
});

export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  resetState,
  updateFormData,
  setActiveTab,
  setDataList,
  setTotalData,
  clearModuleState
} = mst07categorySlice.actions;

export default mst07categorySlice.reducer;
